import React, {useState,useEffect,useRef} from 'react';
import './Radix.css';
import MainContent from './components/MainContent/MainContent';
import Strength from './components/Strength/Strength';
import Trial from './components/Trial/Trial';
import ProductPage from './components/ProductPage/ProductPage';
import Faq from './components/Faq/Faq';


// Import images from assets folder
import highPerformerBadge from '../../../assets/High-Performer-2022.svg';
import fasterGrowingBadge from '../../../assets/fastest-growing-software-products-2023.webp';
import customerSupportBadge from '../../../assets/CustomerSupportBadge.webp';
import desktopMobileImage from '../../../assets/DesktopMobileImage.webp';
import radixImage from '../../../assets/RadixProduct.webp'; // Assuming this is the image for the logo
import { fetchPageMetaData } from '../../../services/metaService';



const Radix = () => {
  const productPageRef = useRef(null);
  const trialRef = useRef(null);
  const [metaData,setMetaData]=useState({});
  useEffect(()=>{
    const MetaData=async()=>{
        const data=await fetchPageMetaData('Radix');
        setMetaData(data[0]);
    }
    MetaData();
  },[])
  useEffect(()=>{
    if (metaData){
      // Update the page title 
      document.title=metaData.metaTitle || "Tripta Innovations Private Limited Radix Page"
      // Meta description
      const metaDescription=document.querySelector('meta[name="description"]');
      if (metaDescription){
        metaDescription.setAttribute("content",metaData.metaDescription || "Default Description");
      }else {
        const description = document.createElement("meta");
        description.name = "description";
        description.content = metaData.metaDescription || "Default Description";
        document.head.appendChild(description);
      }
      // Meta Image
      const metaImage=document.querySelector('meta[property="og:image"]');
      if (metaImage){
        metaImage.setAttribute("content",`${process.env.REACT_APP_STRAPI_API_BASE_URL}${metaData.metaImage?.url}` || "Default Image URL");
      }else{
        const image=document.createElement("meta");
        image.setAttribute("property","og:image");
        image.setAttribute("content",`${process.env.REACT_APP_STRAPI_API_BASE_URL}${metaData.metaImage?.url}` || "Default Image URL");
        
        document.head.appendChild(image);
      }

      // Canonical URL
      const canonicalLink = document.querySelector('link[rel="canonical"]');
      
      if (canonicalLink) {
        canonicalLink.setAttribute("href", metaData.canonicalUrl || window.location.href);
      } else {
        const link = document.createElement("link");
        link.rel = "canonical";
        link.href =metaData.canonicalUrl || window.location.href;
        document.head.appendChild(link);
      }
      
    }
  },[metaData])
  
  
  const scrollToProductPage = () => {
    productPageRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToTrial = () => {
    trialRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    
    <div className="radix">

      <MainContent 
        scrollToProductPage={scrollToProductPage} 
        scrollToTrial={scrollToTrial} 
        desktopMobileImage={desktopMobileImage}
        highPerformerBadge={highPerformerBadge}
        fasterGrowingBadge={fasterGrowingBadge}
        customerSupportBadge={customerSupportBadge}
        mainPageTitleText="Accounting that adapts to your Business" 
        mainPageDescription="Advanced Accounting Redefined. Radix delivers a comprehensive, evolving accounting solution, perfect for any business domain."
      />
      <Strength/> 
      <div ref={trialRef}>
        <Trial TestimonialCards={{}} /> 
      </div>
      <div ref={productPageRef}>
        <ProductPage 
          exeFiles={{}}  
          radixImage={radixImage}
        />
      </div>
      <Faq Faqs={{}} />
    </div>
  );
};

export default Radix;
